// extracted by mini-css-extract-plugin
export default {"unavailable":"UnavailableTag_unavailable__2kfwh","messageContainer":"UnavailableTag_messageContainer__hcg5T","mainText":"UnavailableTag_mainText__+6-Em"};